'use client';
function omit(e, t) {
    return Object.keys(e).reduce((n, r)=>(-1 !== t.indexOf(r) || (n[r] = e[r]), n), {});
}

export { omit };
